<template>
  <div class="investOrder">
    <div class="nav">
      <span :class="{active:state==1}" @click="state=1">{{$t('btn.b75')}}({{count}})</span>
      <span :class="{active:state==2}" @click="state=2">{{$t('btn.b76')}}</span>
      <span :class="{active:state==3}" @click="state=3">{{$t('btn.b77')}}</span>
      <span :class="{active:state==0}" @click="state=0">{{$t('btn.b78')}}</span>
    </div>
    <div class="investList">
      <Datatable
        url="/Member/RZJLoan/InvestmentOrderList"
        field="InvestSchemeList"
        :th="[$t('label.w51'),$t('label.w1'),$t('label.w3'),$t('label.w233'),$t('label.w53'),$t('label.w54'),$t('label.w64'),$t('label.w57'),$t('label.w19')]"
        :filter="{state}"
        ref="Datatable"
        @on-data="ondata"
        :tip="$t('msg.m102')"
      >
        <template v-slot="{item}">
          <tr>
            <td>
              <router-link :to="{name:'borrowDetails',params:{id:item.LoanSchemeId}}">
                {{item.Number}}
                <span class="text-primary" v-if="item.LoanType==1">
                  <br />
                  {{$t('msg.m99')}}
                </span>
              </router-link>
            </td>
            <td>¥ {{item.Amount | money}}</td>
            <td>{{item.Rate.toFixed(1)}}%</td>
            <td class="mons">
              <span class="s1">¥ {{item.TotalInterestAmount | money}}</span>
              <span
                class="s2"
              >={{ item.TotalInterestAmounts }}[利息]-{{ item.TotalInvestManagementFeeAmount }}[管理费]</span>
            </td>
            <td>
              <span :class="{colorR:[6,7,100,200].indexOf(item.State)>-1}">{{item.StateName}}</span>
              <span v-if="item.State==0">[{{item.Progress}}%]</span>
            </td>
            <!-- <td>{{item.Phase}} / {{item.TotalPhase}}</td> -->
            <td v-show="item.LoanCycleValue>=30">{{item.Phase}} / {{item.TotalPhase}}</td>
            <td v-show="item.LoanCycleValue<30">{{item.LoanCycleValue}}天</td>
            <td>¥ {{item.BeenIncomeAmount | money}}</td>
            <td>{{item.RePayTime}}</td>
            <td>
              <span class="opebtn" v-if="[1,2,6,7,100,200].indexOf(item.State)>-1">
                <a
                  href="javascript:;"
                  @click="detail(item)"
                >{{detailId===item.Id?$t('btn.b69'):$t('btn.b70')}}</a>
              </span>
              <span class="opebtn" v-if="[0].indexOf(item.State)>-1">
                <a href="javascript:;" @click="openModal('cancel',item)">{{$t('btn.b39')}}</a>
              </span>
            </td>
          </tr>
          <tr v-if="detailId===item.Id">
            <td colspan="9" class="detailtd">
              <div :style="{position:'relative',minHeight:'74px'}">
                <Spin fix v-show="detailloading"></Spin>
                <table>
                  <tr>
                    <th>{{$t('label.w54')}}</th>
                    <th>{{$t('label.w58')}}</th>
                    <th>{{$t('label.w65')}}</th>
                    <th>{{$t('label.w232')}}</th>
                    <th>{{$t('label.w66')}}</th>
                    <th>{{$t('label.w67')}}</th>
                    <th>{{$t('label.w68')}}</th>
                    <th>{{$t('label.w62')}}</th>
                  </tr>
                  <tr v-for="v in detailList" :key="v.Id">
                    <td>{{v.Phase}}</td>
                    <td>{{v.RepayAt}}</td>
                    <td>¥ {{v.Amount | money}}</td>
                    <td class="mons">
                      <span class="s1">¥ {{v.Interest | money}}</span>
                      <span class="s2">={{ v.Interests }}[利息]-{{v.InvestManagementFeeAmount }}[管理费]</span>
                    </td>
                    <td>¥ {{v.OverdueAmount | money}}</td>
                    <td>¥ {{v.InvestAddInterest | money}}</td>
                    <td :class="{colorR:v.IsRed}">{{v.StateName}}</td>
                    <td>{{v.RepayedAt}}</td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>
        </template>
      </Datatable>
    </div>
    <Cancel ref="Cancel" type="invest" @done="refresh" />
    <Incomes ref="Incomes" />
  </div>
</template>


<script>
import Datatable from "@/components/datatable";
import Cancel from "./modal/cancel";
import Incomes from "@/pages/invest/modal/incomes";
export default {
  components: { Datatable, Cancel, Incomes },
  data() {
    return {
      state: 1,
      count: 0,
      detailId: "",
      detailList: [],
      detailloading: false,
    };
  },
  destroyed() {
    window.toCheck = null;
  },
  mounted() {
    window.toCheck = () => {
      this.$refs.Incomes.value = true;
    };
  },
  methods: {
    //查看收益窗口
    // toCheck() {
    //   this.$refs.Incomes.value = true;
    // },
    ondata(res) {
      this.count = res.UnFinishedCount;
    },
    refresh() {
      this.$refs.Datatable.refresh();
    },
    detail(v) {
      if (this.detailloading) return;
      if (this.detailId == v.Id) return (this.detailId = "");
      this.detailId = v.Id;
      this.detailloading = true;
      this.detailList = [];
      this.$axios
        .get(
          "/Member/RZJLoan/InvestmentIncomeHistory?investmentSchemeId=" + v.Id
        )
        .then((res) => {
          this.detailloading = false;
          if (!res.err) {
            this.detailList = res;
          }
        });
    },
    openModal(t, v) {
      switch (t) {
        case "cancel":
          this.$refs.Cancel.item = v;
          this.$refs.Cancel.modal = true;
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.investOrder {
  margin-top: 20px;
  min-height: 600px;
  .colorR {
    color: #f64750;
  }
  .nav {
    margin-bottom: 30px;
    span {
      display: inline-block;
      height: 40px;
      min-width: 86px;
      border-radius: 8px;
      line-height: 40px;
      text-align: center;
      color: #7b7b7c;
      font-size: 14px;
      cursor: pointer;
      margin-right: 10px;
    }
    .active {
      background: rgba(94, 143, 252, 1);
      color: #fff;
      font-weight: 500;
    }
  }
}
.detailtd {
  padding: 0 !important;
  background: rgba(233, 234, 238, 1);
  line-height: 20px;
  box-shadow: inset 0px 30px 15px -20px rgba(0, 0, 0, 0.1);
  tbody {
    background: none !important;
  }
  tr {
    border-color: #dbdce0;
    &:last-child {
      border-bottom: 0;
    }
  }
  td,
  th {
    padding: 8px;
    height: auto;
    &:first-child {
      text-align: left;
      padding-left: 30px;
    }
  }
  th {
    font-size: 12px;
    color: #7b7b7c;
    font-weight: normal;
  }
}
td {
  height: 60px;
}
.opebtn {
  &:before {
    content: "|";
    margin: 0 8px;
    color: #ccc;
  }
  &:first-child {
    &:before {
      display: none;
    }
  }
}
.mons {
  position: relative;
  cursor: pointer;
  .s2 {
    position: absolute;
    bottom: -40px;
    left: 45px;
    display: none;
    width: 200px;
    padding: 10px 0 15px 10px;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    background: #fff;
    font-size: 14px;
    color: #000000;
    z-index: 5;
  }
  &:hover {
    .s2 {
      display: block;
    }
  }
}
</style>

